import FieldWrapper from 'components/FieldWrapper';
import Creatable from 'react-select/creatable';
import {Props as SelectProps} from 'components/Select';
import classNames from 'classnames';
import '../Select/Select.scss';
interface Props extends SelectProps {
  label?: string;
  error?: string;
  onCreateOption?: (inputValue: string) => void;
}

function CreatableSelect({label, error, size, className, ...restProps}: Props) {
  return (
    <FieldWrapper label={label} error={error}>
      <Creatable
        isClearable
        classNamePrefix="Select"
        className={classNames(`Select-${size}`, !!error && 'error', className)}
        {...restProps}
      />
    </FieldWrapper>
  );
}

CreatableSelect.defaultProps = {
  size: 'md',
};

export default CreatableSelect;
